import { z } from 'zod'

export const editProfileFormSchema = z.object({
  avatar: z.string().nullable().optional(),
  bio: z
    .string()
    .max(700)
    .nullable()
    .optional()
    .transform(val => (val === '' ? null : val)),
  email: z.string().email().min(1),
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  personalEmail: z.string().email().optional().nullable().or(z.literal('')),
  phone: z.string().nullable().optional(),
})
